<template>
  <div class="tx-dealersearch module-dealersearch-heading">
    <div class="heading__heading">
      <span class="heading beta">{{ $t('dealersearch.heading.heading') }}</span>
    </div>
    <div class="heading__text">
      <span>{{ $t('dealersearch.heading.text') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DealersearchHeading'
}
</script>
